// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__26nyU","footer":"styles_footer__3Z1dl"};